import {useContext} from 'react'
import gql from 'graphql-tag'
import getDomain from '@helpers/websites/getDomain'
import WebsiteBusinessTypeContext from '@helpers/misc/WebsiteBusinessTypeContext'
import useQuery from '@packages/apollo-hooks/lib/useApolloQuery'
import isServerSide from '@helpers/misc/isServerSide'

export default function useWebsiteBusinessType() {
  const businessType = useContext(WebsiteBusinessTypeContext)

  const {website} = useQuery({
    query: gql`
      query getWebsiteBusinessTypeFromDomain_cached($domain: String) {
        website(domain: $domain) {
          _id
          businessType
        }
      }
    `,
    variables: {domain: getDomain()},
    fetchPolicy: 'cache-first',
    omit: isServerSide(),
    partial: true
  })

  if (businessType) return businessType

  if (!website || !getDomain()) return null

  return website.businessType
}
